export default __webpack_public_path__ + "static/media/FlyingFrog15.3ccd05cd.png";